import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Forms } from '../../components/backgrounds/Forms'
import { Primary } from '../../components/buttons/Primary'
import { Steps, titles } from '../../components/buttons/Steps'
import Numeral from 'react-numeral'
import {
    companyDatas,
    products,
    requisitos,
    desembolsos,
    pays,
    retractos,
    abonos,
    autorizaciones,
    reportes,
    notificaciones,
    derechos,
    firmas,
    fisicos,
    identidades,
    veracidades,
    contactos,
    pagares,
} from '../../components/legal/Content';
import { validateSessionAndJwtToken } from '../../utils/validateTokenSession';
import { FirmaE } from '../../components/legal/Firma';
import { CreditUserContext } from '../../context/CreditUser/CreditUserContext';
import { FormOneContext } from '../../context/FormOne/FormOneContext';
import { FormTwoContext } from '../../context/FormTwo/FormTwoContext';
import { AuthContext } from '../../context/Auth/AuthContext';
import { HttpRequest } from '../../services/httpRequest';
import moment from 'moment';
import { FunnelService } from '../../services/funnel/funnel.service';
import { returnToSignin } from '../../utils/returnToSign';

export function ContratoPage() {
    const { state } = useLocation();
    const [documento, setDocumento] = useState("");
    const [isRenovateCredit, setIsRenovateCredit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const { creditUser, updateCreditUser } = useContext(CreditUserContext);
    const { formOne, updateFormOne } = useContext(FormOneContext);
    const { formTwo, updateFormTwo } = useContext(FormTwoContext);
    const { mail, phone, updateMail, updatePhone } = useContext(AuthContext);

    const tmlv = JSON.parse(localStorage.getItem('tmlv') ?? "{}")[0];

    const navigate = useNavigate();

    const admon = 60000;

    //Calcular IVA
    const iva = Math.round(admon * (19 / 100));

    let plazoEnDias = creditUser.termInDays;

    //Calcular interes
    const interest = Math.round(
        parseInt(creditUser.approvedQuota) * (0.0626666 / 100) * plazoEnDias
    );

    const total = Math.round(isRenovateCredit ? parseInt(creditUser.requestedAmount) + interest + admon + iva : parseInt(creditUser?.approvedQuota) + interest + admon + iva);


    const userDatas = [

        { title: "Nombre completo:", value: `${formOne.firstname || ""} ${formOne.secondname} ${formOne.firstlastname} ${formOne.secondlastname}` },
        { title: "Documento:", number: creditUser.documento || documento },
        {
            title: "Dirección de residencia",
            value: `${formOne.cityAddress}, ${formOne.depAddress}`,
        },
        { title: "Correo electrónico", value: mail || localStorage.getItem('phone') },
        { title: "Celular", value: phone || localStorage.getItem('phone') },
        { title: "Banco", value: formTwo.bankAccount },
        { title: "Tipo de cuenta", value: formTwo.typeBankAccount },
        { title: "Número de cuenta", value: formTwo.accountNumber },

    ];

    const conditions = [

        { title: "Valor del crédito:", number: isRenovateCredit ? creditUser?.requestedAmount : creditUser.approvedQuota },
        { title: "Valor cuota:", number: total || creditUser.totalToPay },
        { title: "Número de cuotas:", value: 1 },
        { title: "Plazo:", value: `${plazoEnDias || 0} días` },
        { title: "Fecha de aprobación:", value: creditUser.approvedDate || moment().format('DD/MM/YYYY') },
        { title: "Fecha de vencimiento:", value: creditUser.paydayLimit },
        { title: "Tasa de interés aplicada (T.E.A):", value: `${25}% E.A` },
        {
            title: "Tasa de interés máxima legal vigente (T.E.A.):",
            value: `${tmlv?.rate} ${tmlv?.percent} ${tmlv?.text}`,
        },
        { title: "Tasa de interés moratorio:", value: `${tmlv?.rate} ${tmlv?.percent} ${tmlv?.text}` },
        { title: "Administración (opcional):", number: admon },
        { title: "IVA:", number: iva },
        { title: "Total a pagar:", number: total || creditUser.totalToPay },
    ];

    const debitos = [
        `El DEUDOR otorga mediante la instrumentación de la firma electrónica del presente contrato a Galilea específica autorización para que, a la orden de ésta, se cursen los débitos en su cuenta bancaria, con el fin de aplicarlos a los servicios otorgados. Estos débitos se aplicarán por el tiempo que se encuentre vigente la obligación, a partir del día 01 en mora, por sistema de débito automático a la cuenta bancaria No. ______ de su titularidad del banco _____ de tipo ____, o cualquier otra que posea y haya registrado en la plataforma o de conocimiento de Galilea galilea.co de acuerdo al histórico de créditos o informada en el futuro bajo el mismo régimen o régimen similar, por obligaciones aceptadas por el DEUDOR adhiriéndose al sistema de débito directo o indirecto normados, sobre las cuales desde ya autoriza a Galilea o a Acciones y Valores Comisionista de Bolsa S.A. o cualquiera de sus aliados comerciales y financieros a debitar de cualesquiera de las cuentas bajo su titularidad los montos y cargos relacionados con las obligaciones asumidas, más los intereses causados en caso de mora, gastos de cobranza, atraso o pago parcial que correspondan, según indique Galilea. La presente autorización es permanente e irrevocable, mientras subsista la obligación referenciada precedentemente. Galilea se reserva el derecho de aplicar el débito automático en la fecha fijada como vencimiento y hacer exigible el pago de la obligación desde el primer día de mora, en el caso que no se evidencie el pago voluntario por parte del DEUDOR.`,
    ];

    const loadInfoUser = async () => {
        try {

            const data = await HttpRequest.getInfoUser(localStorage.getItem('doc'));
            return data.message.info;
        } catch (error) {
            console.log(error);
        }
    }

    const loadInfoUserAuth = async () => {
        try {
            const data = await HttpRequest.getUserAuth(localStorage.getItem('doc'));
            return data.message.user;
        } catch (error) {
            console.log(error);
        }
    }

    const updateformsUtil = async (data) => {
        updateFormOne({
            firstname: data.firstname,
            secondname: data.secondname,
            firstlastname: data.firstlastname,
            secondlastname: data.secondlastname,
            datexpedia: data.datexpedia,
            maritalStatus: data.maritalStatus,
            age: data.age,
            gender: data.gender,
            educationLevel: data.educationLevel,
            depAddress: data.depAddress,
            cityAddress: data.cityAddress
        })

        updateFormTwo({
            ocupation: data.ocupation,
            economicActivity: data.economicActivity,
            monthlyExpenses: data.monthlyExpenses,
            stratum: data.stratum,
            bankAccount: data.bankAccount,
            typeBankAccount: data.typeBankAccount,
            accountNumber: data.accountNumber
        })

        updateCreditUser({
            ...creditUser,
            documento: documento || localStorage.getItem('doc'),

        });

        return;
    }

    const handleAddTimeline = async (idOperation, creditId) => {
        try {
            let payloadTimeline = {
                name: "Contrato",
                description: "Contrato de crédito",
                pathView: "/contrato",
                error: {
                    hasError: false,
                    errorMessage: ""
                },
                success: {
                    hasSuccess: true,
                    successMessage: "Ok"
                },
                styles: {
                    TimelineOppositeContent: {
                        sx: { m: "auto 0" },
                        align: "left",
                        variant: "body2",
                        color: "text.secondary",
                        style: { fontFamily: "GT Walsheim Pro", fontWeight: "lighter" }
                    },
                    TimelineDot: {
                        color: "primary"
                    },
                    TimelineContent: {
                        Typography: {
                            variant: "h6",
                            component: "span"
                        },
                        sx: { py: "12px", px: 2 }
                    },
                    icon: {
                        name: "CiViewList",
                        size: "1.5rem"
                    }
                }
            };
            if (idOperation) {
                let { message } = await FunnelService.addTimelineByOperationId(idOperation, payloadTimeline)
                return message;
            } else if (creditId) {
                let { message } = await FunnelService.addTimelineByCreditId(creditId, payloadTimeline)
                return message;
            } else {
                return 'IdOperation or creditId is null.'
            }
        } catch (error) {
            return error;
        }
    }

    useEffect(() => {
        const validSessionAndTokenJwt = async () => {
            try {
                let isValidToken = await validateSessionAndJwtToken();
                return isValidToken;
            } catch (error) {
                return false;
            }
        };

        const loadInfo = async () => {
            let info = await loadInfoUser();
            return info;
        }

        validSessionAndTokenJwt()
            .then(async (isValidToken) => {
                if (isValidToken) {
                    if (state) {
                        if (state.isRenovateCredit === true) {
                            setIsRenovateCredit(true);
                            setDocumento(state.doc);
                        }
                    }
                    loadInfoUserAuth()
                            .then(async (userauth) => {
                                //Agregar timeline a funnel
                                let idOperation = localStorage.getItem('idOperation');
                                if (idOperation) {
                                    handleAddTimeline(idOperation, null)
                                        .then((message) => console.log(message))
                                        .catch(e => console.log(e))
                                } else {
                                    handleAddTimeline(null, localStorage.getItem('credit_id'))
                                        .then((message) => console.log(message))
                                        .catch(e => console.log(e))
                                }
                                updateMail(userauth?.email);
                                updatePhone(userauth?.phone);
                                localStorage.setItem('phone', userauth?.phone);
                                localStorage.setItem('email', userauth?.email);
                                let info = await loadInfo();
                                await updateformsUtil(info);
                                setIsLoading(false);
                            })
                            .catch(err => console.log(err));
                } else {
                    returnToSignin(navigate);
                }
            })
            .catch((e) => {
                console.log(e);
                returnToSignin(navigate);
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return (
            <div className='bg-red bg-opacity-10'>
                <Steps
                    estado1='complete'
                    estado2='complete'
                    estado3='complete'
                    estado4='current'
                />
                <Forms
                    title={titles[3].name}
                    description={'Cargando contrato...'}
                    form={
                        <form action="#" method="POST">
                            <div className='shadow-lg overflow-hidden rounded-md'>

                            </div>
                        </form>
                    }
                />
            </div>
        )
    }

    return (
        <div className='bg-purpleLight h-screen'>
            <Steps
                estado1='complete'
                estado2='complete'
                estado3='complete'
                estado4='current'
            />
            <Forms
                title={titles[3].name}
                description={'Lee con atención el contrato de tu crédito y si estás de acuerdo, presiona "Aceptar contrato".'}
                form={
                    <form action="#" method="POST">
                        <div className='shadow-lg overflow-hidden rounded-md'>
                            <div className="px-4 py-5 bg-white sm:p-6">
                                <div className='overflow-y-scroll h-96'>
                                    <div className='text-center font-bold'>
                                        <h2 className='text-xl uppercase'>Contrato de crédito rotativo</h2>
                                        <h2 className='my-4'>GRUPO EMPRESARIAL ANAV S.A.S - Galilea</h2>
                                    </div>
                                    <div>
                                        <div className='mb-2'>
                                            <span className='uppercase font-bold'>Acreedor:</span>
                                        </div>
                                        {companyDatas.map((companyData, index) => (
                                            <ul key={index} role='list' className='marker:text-purple list-disc'>
                                                <div key={index} className='pl-6 grid grid-cols-5'>
                                                    <div className='col-span-2'>
                                                        <li>{companyData.title}</li>
                                                    </div>
                                                    <div className='col-span-3 ml-2'>
                                                        <span>{companyData.value}</span>
                                                    </div>
                                                </div>
                                            </ul>
                                        ))}
                                    </div>
                                    <div className='mt-6'>
                                        <div className='mb-2'>
                                            <span className='uppercase font-bold'>Deudor:</span>
                                        </div>
                                        {userDatas.map((userData, index) => (
                                            <ul key={index} role='list' className='marker:text-purple list-disc'>
                                                <div key={index} className='pl-6 grid grid-cols-5'>
                                                    <div className='col-span-2'>
                                                        <li>{userData.title}</li>
                                                    </div>
                                                    <div className='col-span-3 ml-2'>
                                                        <Numeral format={'0,0'} value={userData.number} />
                                                        <span>{userData.value}</span>
                                                    </div>
                                                </div>
                                            </ul>
                                        ))}
                                    </div>


                                    <div className='mt-6'>
                                        <p className=''>
                                            Entre los suscritos <span className='font-bold'>GRUPO EMPRESARIAL ANAV S.A.S. </span>
                                            sociedad legalmente establecida conforme las normatividades del país lo exigen,
                                            identificada con NIT: <span className='font-bold'>901.582.748-5</span>  y quién para los efectos del presente contrato
                                            se denominará <span className='font-bold'>EL ACREEDOR</span> y por la otra parte, y representada legalmente por
                                            <span className='ml-2 font-bold'>{userDatas[0].value}</span>, mayor de edad identificada con cédula de ciudadanía No.
                                            <Numeral className='font-bold ml-2' format={'0,0'} value={userDatas[1].number} /> quien para efectos del
                                            presente contrato se denominará <span className='font-bold'>EL DEUDOR</span>; manifiestan que, siendo plenamente capaces,
                                            celebran el presente <span className='font-bold'>CONTRATO DE MUTUO</span> que se regirá por las normas aplicables a la materia
                                            conforme a la legislación colombiana, y especialmente por los siguientes:
                                        </p>
                                    </div>

                                    <div className='my-6'>
                                        <div>
                                            <span className='uppercase font-bold'>1. Producto</span>
                                        </div>
                                        {products.map((product, index) => (
                                            <p key={index} className='mt-4'>
                                                {product}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>2. Requisitos</span>
                                        </div>
                                        <p>
                                            Para acceder al producto ofertado por Galilea, debes reunir los siguientes requisitos:
                                        </p>
                                        <div className='mt-4'>
                                            {requisitos.map((requisito, idx) => (
                                                <ul key={idx} role='list' className='marker:text-purple list-disc'>
                                                    <li className='my-0 ml-6'>{requisito}</li>
                                                </ul>
                                            ))}
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div>
                                            <span className='uppercase font-bold'>3. Tiempos de desembolso</span>
                                        </div>
                                        {desembolsos.map((desembolso, index) => (
                                            <p key={index} className='mt-4'> {desembolso} </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>4. Características del crédito rotativo aprobado</span>
                                            <ul role='list' className='mt-4 marker:text-purple list-disc'>
                                                {conditions.map((condition, index) => (
                                                    <div key={index} className='pl-6 grid grid-cols-5'>
                                                        <div className='col-span-3'>
                                                            <li>{condition.title}</li>
                                                        </div>
                                                        <div className='col-span-2 ml-2'>
                                                            <Numeral format={'$0,0'} value={condition.number} />
                                                            <span> {condition.value} </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>5. Medios de pago</span>
                                        </div>
                                        <div>
                                            <p> El DEUDOR podrá realizar el pago de sus obligaciones a través de los medios de pago dispuestos y debidamente autorizados registrados por GRUPO EMPRESARIAL ANAV S.A.S. – Galilea, que se describen a continuación y a su vez, que se encuentran al alcance del público las 24 horas en la plataforma web galilea.co. </p>
                                            <div className='mt-4'>
                                                {pays.map((pay, idx) => (
                                                    <div key={idx}>
                                                        <ul key={idx} role='list' className='marker:text-purple list-disc'>
                                                            <li className='my-0 ml-6'> {pay} </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>6. Derecho al retracto</span>
                                        </div>
                                        <div>
                                            <p> El DEUDOR, en ejercicio de su derecho al retracto podrá solicitar el desistimiento del crédito requerido, dentro de los cinco (5) días, contados a partir del desembolso del crédito, por lo que el DEUDOR deberá realizar la devolución de los recursos desembolsados asumiendo a su vez los costos de adquisición del servicio que se describen a continuación: </p>
                                            <div className='mt-4'>
                                                {retractos.map((retracto, idx) => (
                                                    <ul role='list' className='marker:text-purple list-disc'>
                                                        <div key={idx} className='pl-6 grid grid-cols-5'>
                                                            <div className='col-span-2'>
                                                                <li>{retracto.title}</li>
                                                            </div>
                                                            <div className='col-span-3 ml-2'>
                                                                <Numeral format={'$0,0'} value={retracto.number} />
                                                            </div>
                                                        </div>
                                                    </ul>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>7. Pagos anticipados, totales o parciales</span>
                                        </div>
                                        <div>
                                            <p> El DEUDOR tiene como derecho realizar pagos anticipados, totales o parciales, del crédito o de sus cuotas que serán abonados en el siguiente orden: </p>
                                            <div className='mt-4'>
                                                {abonos.map((abono, idx) => (
                                                    <div key={idx}>
                                                        <ul role='list' className='marker:text-purple list-disc'>
                                                            <li className='my-0 ml-6'> {abono} </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>8. Cobranza prejuridica</span>
                                        </div>
                                        <div>
                                            <p> Los gastos de cobranza equivalen a mil quinientos pesos ($1.500) más IVA por cada día en mora que incurra el DEUDOR y serán cobrados máximo hasta el día 90 de mora. </p>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>9. AUTORIZACIONES GENERALES PARA EL TRATAMIENTO DE DATOS PERSONALES</span>
                                        </div>
                                        {autorizaciones.map((autorizacion, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {autorizacion}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>10. AUTORIZACIÓN PARA LA CONSULTA, REPORTE ANTE LAS CENTRALES DE RIESGO FINANCIERAS Y A TERCEROS</span>
                                        </div>
                                        {reportes.map((reporte, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {reporte}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>11. Notificación previa al reporte</span>
                                        </div>
                                        {notificaciones.map((notificacion, idx) => (
                                            <div key={idx}>
                                                <p className='mt-4'>
                                                    {notificacion.parrafo}
                                                    <span className='italic ml-2'>{notificacion.cita}</span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>12. Derechos del titular</span>
                                        </div>
                                        {derechos.map((derecho, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {derecho}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>13. INSTRUMENTACIÓN DE LA FIRMA ELECTRÓNICA A TRAVÉS DEL USO DE LA PLATAFORMA TECNOLÓGICA (OPCIONAL)</span>
                                        </div>
                                        {firmas.map((firma, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {firma}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>14. CELEBRACIÓN DEL CONTRATO A TRAVÉS DE PROCESO FÍSICO (OPCIONAL)</span>
                                        </div>
                                        <div>
                                            <p> GRUPO EMPRESARIAL ANAV S.A.S. – Galilea, ha dispuesto para el titular que no desee instrumentar la firma electrónica del presente contrato a través de la plataforma web galilea.co, un canal adicional para realizar la solicitud del crédito mediante el envío de la siguiente información a la dirección de correspondencia física Cl 79 No. 11 66 Ed Spaces. </p>
                                            <div className='mt-4'>
                                                {fisicos.map((fisico, idx) => (
                                                    <div key={idx}>
                                                        <ul role='list' className='marker:text-purple list-disc'>
                                                            <li className='my-0 ml-6'> {fisico} </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                            <p className='mt-6'>El titular se obliga a suministrar información veraz, completa, actualizada y comprobable, así mismo, este deberá garantizar que a partir de los datos suministrados no busca inducir al error en los procesos internos para lo cual Galilea en procura de la veracidad realizará las rectificaciones respectivas siendo estas últimas de pleno conocimiento del usuario. No obstante, Galilea se reserva el derecho de aprobación de la solicitud de crédito y los tiempos para su respuesta.</p>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>15. AUTORIZACIONES PARA EL DÉBITO AUTOMÁTICO</span>
                                        </div>
                                        {debitos.map((debito, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {debito}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>16. Validación de indentificación personal</span>
                                        </div>
                                        <div>
                                            <p> Galilea ha desarrollado protocolos de prevención al fraude personal buscando proteger la información del DEUDOR para lo cual ha creado validaciones de seguridad que se describen a continuación: </p>
                                            <div className='mt-4'>
                                                {identidades.map((identidad, idx) => (
                                                    <div key={idx}>
                                                        <ul role='list' className='marker:text-purple list-disc'>
                                                            <li className='my-0 ml-6'> {identidad} </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>17. VERACIDAD DE LA INFORMACIÓN SUMINISTRADA</span>
                                        </div>
                                        {veracidades.map((veracidad, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {veracidad}
                                            </p>
                                        ))}
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>18. MEDIOS DE CONTACTO SAC, COBRANZA Y PQRS</span>
                                        </div>
                                        <div>
                                            <p> El DEUDOR, podrá ejercer su derecho de información respecto al crédito a su cargo y a interponer peticiones, quejas y reclamos, en los siguientes canales: </p>
                                            <div className='mt-4'>
                                                {contactos.map((contacto, idx) => (
                                                    <ul key={idx} className='pl-6 grid grid-cols-5'>
                                                        <div className='col-span-2'>
                                                            <li className='font-bold'>{contacto.title}</li>
                                                        </div>
                                                        <div className='col-span-3 ml-2'>
                                                            <span> {contacto.value} </span>
                                                        </div>
                                                    </ul>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='my-6'>
                                        <div className='mb-4'>
                                            <span className='uppercase font-bold'>19. Pagaré y carta de instrucciones</span>
                                        </div>
                                        {pagares.map((pagare, idx) => (
                                            <p key={idx} className='mt-4'>
                                                {pagare}
                                            </p>
                                        ))}
                                    </div>
                                    <FirmaE />
                                </div>
                                <div className="flex px-4 py-6 md:flex md:justify-end bg-white text-right sm:px-6">
                                    <div className='md:w-56'>
                                        {isRenovateCredit ?
                                            <Link to={"/pagare"} state={{ isRenovateCredit: true, doc: state.doc, credit_id: state.credit_id }}>
                                                <Primary text='Aceptar contrato.' />
                                            </Link> :
                                            <Link to={"/pagare"}>
                                                <Primary text='Aceptar contrato.' />
                                            </Link>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                }
            />
        </div>
    )
}